module.exports = __webpack_public_path__ + "6dc34f9dfd7954e3baf1b0765bddbff5.jpeg";